import { getPremiumUser } from '../services/getPremiumUser';
import setPremiumUserState from '../mutators/setPremiumUserState';
import store from '../store/store';
import LoadState from '../store/schema/loadState';
import setloadStateOfPremiumUserInfo from '../mutators/setloadStateOfPremiumUserInfo';

export default async function getPremiumUserState() {
    if (store.userInfoLoadState != LoadState.Initialized) {
        setloadStateOfPremiumUserInfo(LoadState.Loading);
        return getPremiumUser().then(response => {
            setPremiumUserState(response);
        });
    }
}
